import { HelpDrawerTrigger } from "app/components/HelpDrawer/HelpDrawerTrigger";

interface Props {
  /** The notification rule name to display in the header */
  name: string;
}

export function EditNotificationRuleHeader({ name }: Props) {
  return (
    <div className="mb-6 flex items-center justify-between gap-2">
      <h1 className="text-title-large">{`Edit Notification Rule: "${name}"`}</h1>
      <HelpDrawerTrigger />
    </div>
  );
}
